// 🏗️ FSD Features Layer - Pricing Business Logic
// PricingPage에서 사용되는 모든 비즈니스 로직을 담당하는 핵심 훅
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router';
import toast from 'react-hot-toast';
import { useAuth } from '@edusense/shared-auth-core';
import { apiBase, PRODUCT_CODES } from '@edusense/shared-pricing-constants';
import { safeApiCall } from '@edusense/shared-utils';
import { getPlans, getSubscriptions, changeSubscriptionPlan, createSubscriptionSession } from '@edusense/payment-client';
var PLAN_ID_TO_PRODUCT_CODE = {
    free: 'FREE_PLAN',
    beginner: 'BEGINNER_MONTHLY',
    advanced: 'ADVANCED_MONTHLY',
    business: 'BUSINESS_YEARLY',
    enterprise: 'ENTERPRISE_YEARLY'
};
var PRODUCT_CODE_TO_PLAN_ID = Object.entries(PLAN_ID_TO_PRODUCT_CODE).reduce(function(acc, param) {
    var _param = _sliced_to_array(param, 2), planId = _param[0], code = _param[1];
    acc[code] = planId;
    return acc;
}, {});
var derivePlanIdFromSubscription = function(subscription) {
    if (typeof (subscription === null || subscription === void 0 ? void 0 : subscription.planId) === 'string' && subscription.planId.length > 0) {
        return subscription.planId;
    }
    var codeCandidate = ((subscription === null || subscription === void 0 ? void 0 : subscription.productPlanCode) || (subscription === null || subscription === void 0 ? void 0 : subscription.productCode) || '').toString().toUpperCase();
    if (codeCandidate && PRODUCT_CODE_TO_PLAN_ID[codeCandidate]) {
        return PRODUCT_CODE_TO_PLAN_ID[codeCandidate];
    }
    var productName = ((subscription === null || subscription === void 0 ? void 0 : subscription.productName) || (subscription === null || subscription === void 0 ? void 0 : subscription.planName) || '').toString().toLowerCase();
    if (productName.includes('free')) return 'free';
    if (productName.includes('beginner') || productName.includes('초급')) return 'beginner';
    if (productName.includes('advanced') || productName.includes('고급')) return 'advanced';
    if (productName.includes('business') || productName.includes('비즈니스')) return 'business';
    if (productName.includes('enterprise') || productName.includes('엔터프라이즈')) return 'enterprise';
    return 'unknown';
};
var parseAmount = function(value) {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string') {
        var digits = value.replace(/[^0-9.]/g, '');
        if (!digits) {
            return undefined;
        }
        var parsed = Number(digits);
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    return undefined;
};
var formatPlanPrice = function(amount, billingCycle, fallback) {
    if (amount === undefined) {
        return fallback !== null && fallback !== void 0 ? fallback : '0원';
    }
    var cycleLabel = billingCycle === 'YEARLY' ? '/년' : billingCycle === 'ONE_TIME' ? '/1회' : '/월';
    return "₩".concat(amount.toLocaleString('ko-KR')).concat(cycleLabel);
};
var resolvePayBaseUrl = function() {
    var _globalThis_process_env, _globalThis_process, _globalThis, _globalThis_process_env1, _globalThis_process1, _globalThis1;
    if (typeof window !== 'undefined') {
        var runtimeUrl = window.__PAY_SERVER_URL__ || window.__PAY_URL__;
        if (runtimeUrl) {
            return runtimeUrl;
        }
    }
    var viteUrl = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.VITE_PAY_URL || import.meta.env.VITE_PAY_BASE_URL : undefined;
    if (viteUrl) {
        return viteUrl;
    }
    var processEnvUrl = ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_process = _globalThis.process) === null || _globalThis_process === void 0 ? void 0 : (_globalThis_process_env = _globalThis_process.env) === null || _globalThis_process_env === void 0 ? void 0 : _globalThis_process_env.VITE_PAY_URL) || ((_globalThis1 = globalThis) === null || _globalThis1 === void 0 ? void 0 : (_globalThis_process1 = _globalThis1.process) === null || _globalThis_process1 === void 0 ? void 0 : (_globalThis_process_env1 = _globalThis_process1.env) === null || _globalThis_process_env1 === void 0 ? void 0 : _globalThis_process_env1.PAY_URL);
    return processEnvUrl || apiBase;
};
var ensureAbsoluteUrl = function(maybeRelative, baseUrl) {
    if (!maybeRelative) {
        return baseUrl;
    }
    if (/^https?:\/\//i.test(maybeRelative)) {
        return maybeRelative;
    }
    return "".concat(baseUrl.replace(/\/$/, ''), "/").concat(maybeRelative.replace(/^\//, ''));
};
var extractPlanMetadata = function(plan) {
    var amount = parseAmount(plan.price);
    var productPlanCode = plan.productPlanCode || plan.productCode || plan.id;
    var _plan_isBillingPlan;
    return {
        id: plan.id,
        name: plan.displayName || plan.name,
        description: plan.description || '',
        features: Array.isArray(plan.features) && plan.features.length > 0 ? plan.features : [
            '기능 정보가 준비 중입니다.'
        ],
        buttonText: plan.isBillingPlan === false ? '무료로 시작하기' : '플랜 선택',
        recommended: Boolean(plan.isRecommended),
        price: formatPlanPrice(amount, plan.billingCycle, plan.price),
        amount: amount,
        productCode: plan.productCode,
        productPlanCode: productPlanCode,
        isBillingPlan: (_plan_isBillingPlan = plan.isBillingPlan) !== null && _plan_isBillingPlan !== void 0 ? _plan_isBillingPlan : true,
        billingCycle: plan.billingCycle
    };
};
var isNonEmptyString = function(value) {
    return typeof value === 'string' && value.trim().length > 0;
};
var coerceToString = function(value) {
    if (isNonEmptyString(value)) {
        return value.trim();
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return String(value);
    }
    return undefined;
};
var pickFirstTruthyString = function() {
    for(var _len = arguments.length, candidates = new Array(_len), _key = 0; _key < _len; _key++){
        candidates[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = candidates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var candidate = _step.value;
            var stringValue = coerceToString(candidate);
            if (stringValue) {
                return stringValue;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
var extractOrderIdFromResponse = function() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            var _source_order, _source_order1, _source_orderInfo, _source_data, _source_data_order, _source_data1, _source_data_orderInfo, _source_data2, _source_session, _source_metadata, _source_subscription;
            if (!source || (typeof source === "undefined" ? "undefined" : _type_of(source)) !== 'object') {
                continue;
            }
            var orderId = pickFirstTruthyString(source.orderId, (_source_order = source.order) === null || _source_order === void 0 ? void 0 : _source_order.orderId, (_source_order1 = source.order) === null || _source_order1 === void 0 ? void 0 : _source_order1.id, (_source_orderInfo = source.orderInfo) === null || _source_orderInfo === void 0 ? void 0 : _source_orderInfo.orderId, (_source_data = source.data) === null || _source_data === void 0 ? void 0 : _source_data.orderId, (_source_data1 = source.data) === null || _source_data1 === void 0 ? void 0 : (_source_data_order = _source_data1.order) === null || _source_data_order === void 0 ? void 0 : _source_data_order.orderId, (_source_data2 = source.data) === null || _source_data2 === void 0 ? void 0 : (_source_data_orderInfo = _source_data2.orderInfo) === null || _source_data_orderInfo === void 0 ? void 0 : _source_data_orderInfo.orderId, source.id, source.sessionId, (_source_session = source.session) === null || _source_session === void 0 ? void 0 : _source_session.id, (_source_metadata = source.metadata) === null || _source_metadata === void 0 ? void 0 : _source_metadata.orderId, (_source_subscription = source.subscription) === null || _source_subscription === void 0 ? void 0 : _source_subscription.orderId);
            if (orderId) {
                return orderId;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
var extractRedirectUrlFromResponse = function() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            var _source_links, _source_data, _source_data1, _source_data2, _source_data3, _source_data4;
            if (!source || (typeof source === "undefined" ? "undefined" : _type_of(source)) !== 'object') {
                continue;
            }
            var redirectUrl = pickFirstTruthyString(source.subscriptionUrl, source.redirectUrl, source.paymentUrl, source.billingUrl, source.url, source.nextRedirectUrl, (_source_links = source.links) === null || _source_links === void 0 ? void 0 : _source_links.redirect, (_source_data = source.data) === null || _source_data === void 0 ? void 0 : _source_data.subscriptionUrl, (_source_data1 = source.data) === null || _source_data1 === void 0 ? void 0 : _source_data1.redirectUrl, (_source_data2 = source.data) === null || _source_data2 === void 0 ? void 0 : _source_data2.paymentUrl, (_source_data3 = source.data) === null || _source_data3 === void 0 ? void 0 : _source_data3.billingUrl, (_source_data4 = source.data) === null || _source_data4 === void 0 ? void 0 : _source_data4.url);
            if (redirectUrl) {
                return redirectUrl;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return undefined;
};
/**
 * usePricingLogic 훅 - PricingPage의 모든 비즈니스 로직 관리
 * @returns 플랜 관리, 구독 관리, 선택 핸들러 등 모든 상태와 함수들
 */ export var usePricingLogic = function() {
    var navigate = useNavigate();
    var _useAuth = useAuth(), accessToken = _useAuth.token, user = _useAuth.user;
    var authenticatedUserId = user === null || user === void 0 ? void 0 : user.id;
    // 컴포넌트 마운트 상태 추적
    var isMountedRef = useRef(true);
    // 로딩 상태 관리
    var _useState = _sliced_to_array(useState(null), 2), loadingPlanId = _useState[0], setLoadingPlanId = _useState[1];
    // 플랜 정보 상태 관리
    var _useState1 = _sliced_to_array(useState([]), 2), availablePlans = _useState1[0], setAvailablePlans = _useState1[1];
    var _useState2 = _sliced_to_array(useState(true), 2), plansLoading = _useState2[0], setPlansLoading = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), plansError = _useState3[0], setPlansError = _useState3[1];
    // 현재 구독 상태 관리
    var _useState4 = _sliced_to_array(useState(null), 2), currentSubscription = _useState4[0], setCurrentSubscription = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), subscriptionLoading = _useState5[0], setSubscriptionLoading = _useState5[1];
    // customInstance가 자동으로 Authorization 헤더를 추가하므로 별도 설정 불필요
    var callSafely = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(fn) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    safeApiCall(fn)
                ];
            });
        });
        return function(fn) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    /**
   * 플랜 정보 조회 함수
   */ var fetchAvailablePlans = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _ref, plansData, _$error, rawPlans, formattedPlans, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    setPlansLoading(true);
                    setPlansError(null);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    console.log('📋 Payment API에서 플랜 정보를 조회합니다...');
                    return [
                        4,
                        callSafely(/*#__PURE__*/ _async_to_generator(function() {
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            getPlans({
                                                productCode: PRODUCT_CODES.EDUSENSE_PLATFORM
                                            })
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        }))
                    ];
                case 2:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), plansData = _ref[0], _$error = _ref[1];
                    if (_$error) {
                        console.error('❌ Payment API 플랜 정보 조회 실패:', _$error.message);
                        setPlansError("플랜 정보를 불러올 수 없습니다: ".concat(_$error.message));
                        setAvailablePlans([]);
                        return [
                            2
                        ];
                    }
                    rawPlans = Array.isArray(plansData) ? plansData : (plansData === null || plansData === void 0 ? void 0 : plansData.plans) || (plansData === null || plansData === void 0 ? void 0 : plansData.content) || (plansData === null || plansData === void 0 ? void 0 : plansData.data) || [];
                    if (!Array.isArray(rawPlans) || rawPlans.length === 0) {
                        console.error('❌ Payment API에서 플랜 데이터가 없습니다.');
                        setPlansError('사용 가능한 플랜이 없습니다. 관리자에게 문의해주세요.');
                        setAvailablePlans([]);
                        return [
                            2
                        ];
                    }
                    formattedPlans = rawPlans.map(function(plan) {
                        try {
                            return extractPlanMetadata(plan);
                        } catch (parseError) {
                            console.error('❌ 플랜 데이터 변환 실패:', parseError, plan);
                            return null;
                        }
                    }).filter(function(plan) {
                        return plan !== null;
                    });
                    if (formattedPlans.length === 0) {
                        console.error('❌ 변환 가능한 플랜이 없습니다.');
                        setPlansError('플랜 데이터 형식 오류. 관리자에게 문의해주세요.');
                        setAvailablePlans([]);
                        return [
                            2
                        ];
                    }
                    console.log('🎯 Payment API에서 받은 플랜 정보:', {
                        plansCount: formattedPlans.length,
                        planNames: formattedPlans.map(function(p) {
                            return p.name;
                        })
                    });
                    setAvailablePlans(formattedPlans);
                    setPlansError(null);
                    console.log('✅ 플랜 정보 상태 업데이트 완료 - Payment API 데이터 사용');
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    console.error('❌ Payment API 플랜 정보 조회 중 오류:', error);
                    setPlansError('플랜 정보를 불러오는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
                    setAvailablePlans([]);
                    return [
                        3,
                        5
                    ];
                case 4:
                    setPlansLoading(false);
                    console.log('📋 플랜 정보 조회 완료');
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        callSafely
    ]);
    /**
   * 현재 구독 상태 확인 함수
   */ var fetchCurrentSubscription = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _ref, subscriptionsData, subscriptionError, subscriptionsList, activeSubscription, _activeSubscription_id, planId, _activeSubscription_amount, amount, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!accessToken) {
                        return [
                            2
                        ];
                    }
                    setSubscriptionLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    console.log('JWT 토큰으로 구독 정보를 조회합니다...');
                    return [
                        4,
                        callSafely(/*#__PURE__*/ _async_to_generator(function() {
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            getSubscriptions()
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        }))
                    ];
                case 2:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), subscriptionsData = _ref[0], subscriptionError = _ref[1];
                    if (subscriptionError) {
                        console.log('구독 정보 조회 실패:', subscriptionError.message);
                        setCurrentSubscription(null);
                        return [
                            2
                        ];
                    }
                    if (subscriptionsData) {
                        console.log('📋 전체 구독 목록:', subscriptionsData);
                        // 응답 구조 확인 후 배열 추출
                        subscriptionsList = Array.isArray(subscriptionsData) ? subscriptionsData : subscriptionsData.subscriptions || subscriptionsData.data || [];
                        console.log('📋 구독 배열:', subscriptionsList);
                        // ACTIVE 상태의 구독 찾기
                        activeSubscription = subscriptionsList.find(function(sub) {
                            return sub.status === 'ACTIVE';
                        });
                        console.log('📋 구독 상태 분석:', {
                            total: subscriptionsList.length,
                            hasActive: !!activeSubscription,
                            activeSubscription: activeSubscription ? {
                                id: activeSubscription.id,
                                status: activeSubscription.status,
                                productName: activeSubscription.productName
                            } : null
                        });
                        if (activeSubscription) {
                            ;
                            // ACTIVE 상태의 구독 처리
                            planId = derivePlanIdFromSubscription(activeSubscription);
                            ;
                            amount = parseAmount((_activeSubscription_amount = activeSubscription.amount) !== null && _activeSubscription_amount !== void 0 ? _activeSubscription_amount : activeSubscription.price);
                            setCurrentSubscription({
                                planId: planId,
                                planName: activeSubscription.productName,
                                status: activeSubscription.status,
                                amount: amount,
                                id: (_activeSubscription_id = activeSubscription.id) === null || _activeSubscription_id === void 0 ? void 0 : _activeSubscription_id.toString()
                            });
                            console.log('현재 활성 구독:', {
                                planId: planId,
                                planName: activeSubscription.productName,
                                status: activeSubscription.status
                            });
                        } else {
                            setCurrentSubscription(null);
                            console.log('활성 구독이 없습니다.');
                        }
                    } else {
                        setCurrentSubscription(null);
                    }
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    console.log('구독 정보 조회 중 오류:', error);
                    setCurrentSubscription(null);
                    return [
                        3,
                        5
                    ];
                case 4:
                    setSubscriptionLoading(false);
                    console.log('✅ 구독 정보 조회 완료');
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        accessToken,
        callSafely
    ]);
    /**
   * 페이지 초기화 함수
   */ var initializePage = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('PricingPage 초기화를 시작합니다...');
                    // 1. 플랜 정보 조회 (인증과 무관하게 먼저 로드)
                    return [
                        4,
                        fetchAvailablePlans()
                    ];
                case 1:
                    _state.sent();
                    if (!(accessToken && authenticatedUserId)) return [
                        3,
                        6
                    ];
                    console.log('인증 정보:', {
                        hasToken: !!accessToken,
                        tokenLength: accessToken === null || accessToken === void 0 ? void 0 : accessToken.length,
                        userId: authenticatedUserId
                    });
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    // JWT 토큰으로 직접 구독 정보 조회
                    return [
                        4,
                        fetchCurrentSubscription()
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    console.error('구독 정보 조회 중 오류:', error);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    console.log('인증 토큰이 없어 구독 정보 조회를 건너뜁니다.');
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchAvailablePlans,
        fetchCurrentSubscription,
        accessToken,
        authenticatedUserId
    ]);
    /**
   * 플랜 선택 핸들러 - 핵심 비즈니스 로직
   */ var handlePlanSelect = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(plan) {
            var _plan_isBillingPlan, isBillingPlan, hasActiveOrPendingSubscription, isChangingPlan, _plan_amount, planAmount, resolvedProductPlanCode, sessionPayload, planChangePayload, _ref, orderResult, orderError, errorCode, errorStatus, errorMessage, changeResponse, responseData, redirectUrl, upgradeOrderId, payBaseUrl, finalUrl, responseData1, orderId, redirectUrl1, payBaseUrl1, targetUrl, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        console.log('🚀 플랜 선택 함수 호출됨:', {
                            planId: plan.id,
                            planName: plan.name,
                            hasAccessToken: !!accessToken,
                            authenticatedUserId: authenticatedUserId,
                            currentSubscription: currentSubscription
                        });
                        // 무료 플랜인 경우 간단한 처리 (실제 구현에서는 필요에 따라 수정)
                        if (plan.id === 'free') {
                            toast.success('무료 플랜이 선택되었습니다!');
                            return [
                                2
                            ];
                        }
                        isBillingPlan = (_plan_isBillingPlan = plan.isBillingPlan) !== null && _plan_isBillingPlan !== void 0 ? _plan_isBillingPlan : plan.id !== 'free';
                        // 유료 플랜 선택 시 인증 확인
                        if (isBillingPlan && (!accessToken || !authenticatedUserId)) {
                            console.error('❌ 인증 정보 부족:', {
                                hasAccessToken: !!accessToken,
                                authenticatedUserId: authenticatedUserId
                            });
                            toast.error('유료 플랜을 선택하시려면 로그인이 필요합니다.');
                            navigate('/login');
                            return [
                                2
                            ];
                        }
                        // 로딩 상태 시작
                        setLoadingPlanId(plan.id);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        toast.loading('주문을 생성하고 있습니다...', {
                            id: 'plan-selection'
                        });
                        console.log('구독용 Order 생성 시작 for user:', authenticatedUserId, 'with plan:', plan.name);
                        // 플랜 변경인지 새 구독인지 확인
                        hasActiveOrPendingSubscription = currentSubscription !== null;
                        isChangingPlan = hasActiveOrPendingSubscription && currentSubscription.planId !== plan.id;
                        console.log('구독용 Order 생성 API 호출 정보:', {
                            hasActiveOrPendingSubscription: hasActiveOrPendingSubscription,
                            isChangingPlan: isChangingPlan,
                            currentPlan: currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.planId,
                            currentStatus: currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.status,
                            newPlan: plan.id,
                            purpose: isChangingPlan ? '기존 구독에서 플랜 변경' : '새 구독용 Order 생성'
                        });
                        planAmount = (_plan_amount = plan.amount) !== null && _plan_amount !== void 0 ? _plan_amount : parseAmount(plan.price);
                        resolvedProductPlanCode = plan.productPlanCode || PLAN_ID_TO_PRODUCT_CODE[plan.id] || plan.productCode || 'FREE_PLAN';
                        sessionPayload = {
                            planId: plan.id,
                            userId: authenticatedUserId !== null && authenticatedUserId !== void 0 ? authenticatedUserId : undefined,
                            productPlanCode: resolvedProductPlanCode,
                            metadata: {
                                amount: planAmount !== null && planAmount !== void 0 ? planAmount : 0,
                                productName: plan.name
                            }
                        };
                        planChangePayload = {
                            newPlanId: plan.id,
                            productPlanCode: resolvedProductPlanCode
                        };
                        console.log('📤 Order 생성 API 요청 정보:', {
                            method: isChangingPlan ? 'changeSubscriptionPlan' : 'createSubscriptionSession',
                            requestBody: isChangingPlan ? planChangePayload : sessionPayload,
                            currentSubscription: currentSubscription,
                            isChangingPlan: isChangingPlan,
                            purpose: '구독용 Order ID 생성'
                        });
                        console.log('📤 createSessionPayload:', sessionPayload);
                        return [
                            4,
                            isChangingPlan && (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.id) ? callSafely(/*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                changeSubscriptionPlan(currentSubscription.id, planChangePayload)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            })) : callSafely(/*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                createSubscriptionSession(sessionPayload)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            }))
                        ];
                    case 2:
                        _ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            2
                        ]), orderResult = _ref[0], orderError = _ref[1];
                        if (!orderError) return [
                            3,
                            5
                        ];
                        console.error('❌ Order 생성 API 에러:', {
                            error: orderError,
                            userId: sessionPayload.userId,
                            planId: sessionPayload.planId,
                            status: orderError.statusCode,
                            message: orderError.message,
                            code: orderError.code,
                            timestamp: new Date().toISOString()
                        });
                        // Check error type and show appropriate message
                        errorCode = orderError.code;
                        errorStatus = orderError.statusCode;
                        errorMessage = orderError.message || '';
                        // Timeout error (ECONNABORTED or timeout in message)
                        if (errorCode === 'ECONNABORTED' || errorMessage.toLowerCase().includes('timeout')) {
                            toast.error('주문 생성 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.', {
                                id: 'plan-selection'
                            });
                            return [
                                2
                            ];
                        }
                        // Authentication errors
                        if (errorStatus === 401 || errorStatus === 403) {
                            if (errorStatus === 403 && errorMessage.toLowerCase().includes('csrf')) {
                                toast.error('보안 검증에 실패했습니다. 페이지를 새로고침해주세요.', {
                                    id: 'plan-selection'
                                });
                            } else {
                                toast.error('인증에 실패했습니다. 다시 로그인해주세요.', {
                                    id: 'plan-selection'
                                });
                                navigate('/login');
                            }
                            return [
                                2
                            ];
                        }
                        if (!(errorStatus === 409)) return [
                            3,
                            4
                        ];
                        console.log('🚨 이미 활성 구독이 있습니다.');
                        toast.error('이미 활성 구독이 있습니다. 기존 구독을 취소하거나 플랜을 변경해주세요.', {
                            id: 'plan-selection'
                        });
                        // 구독 정보를 다시 로드
                        return [
                            4,
                            fetchCurrentSubscription()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                    case 4:
                        // Service unavailable
                        if (errorStatus === 503) {
                            toast.error('서비스가 일시적으로 사용 불가능합니다. 잠시 후 다시 시도해주세요.', {
                                id: 'plan-selection'
                            });
                            return [
                                2
                            ];
                        }
                        // Network errors
                        if (!errorStatus && (errorCode === 'ERR_NETWORK' || errorMessage.toLowerCase().includes('network'))) {
                            toast.error('네트워크 연결을 확인해주세요.', {
                                id: 'plan-selection'
                            });
                            return [
                                2
                            ];
                        }
                        // Generic error
                        toast.error("주문 생성에 실패했습니다: ".concat(errorMessage || '알 수 없는 오류'), {
                            id: 'plan-selection'
                        });
                        return [
                            2
                        ];
                    case 5:
                        console.log('📥 API 응답:', orderResult);
                        if (!orderResult) {
                            console.error('❌ API 응답이 null입니다.');
                            toast.error('요청 처리에 실패했습니다.', {
                                id: 'plan-selection'
                            });
                            return [
                                2
                            ];
                        }
                        if (!isChangingPlan) return [
                            3,
                            7
                        ];
                        changeResponse = orderResult;
                        responseData = (changeResponse === null || changeResponse === void 0 ? void 0 : changeResponse.data) || changeResponse;
                        redirectUrl = extractRedirectUrlFromResponse(changeResponse, responseData);
                        upgradeOrderId = extractOrderIdFromResponse(changeResponse, responseData);
                        if (redirectUrl || upgradeOrderId) {
                            toast.success('업그레이드 차액 결제 페이지로 이동합니다.', {
                                id: 'plan-selection',
                                duration: 2000
                            });
                            payBaseUrl = resolvePayBaseUrl();
                            finalUrl = ensureAbsoluteUrl(redirectUrl || "/subscribe/start-billing?orderId=".concat(upgradeOrderId), payBaseUrl);
                            setTimeout(function() {
                                if (window.ide === 'vscode' && window.vscode) {
                                    window.vscode.postMessage({
                                        messageType: 'openUrl',
                                        data: finalUrl
                                    });
                                } else {
                                    window.location.href = finalUrl;
                                }
                            }, 2000);
                            return [
                                2
                            ];
                        }
                        toast.success((changeResponse === null || changeResponse === void 0 ? void 0 : changeResponse.message) || '플랜이 성공적으로 변경되었습니다.', {
                            id: 'plan-selection'
                        });
                        return [
                            4,
                            fetchCurrentSubscription()
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                    case 7:
                        responseData1 = (orderResult === null || orderResult === void 0 ? void 0 : orderResult.data) || orderResult;
                        orderId = extractOrderIdFromResponse(orderResult, responseData1);
                        redirectUrl1 = extractRedirectUrlFromResponse(orderResult, responseData1);
                        if (!redirectUrl1 && orderId) {
                            redirectUrl1 = "/subscribe/start-billing?orderId=".concat(orderId);
                            console.log('🔧 orderId로 구독 빌링 URL 생성:', redirectUrl1);
                        }
                        if (orderId && redirectUrl1) {
                            toast.success('주문이 준비되었습니다. 결제 페이지로 이동합니다.', {
                                id: 'plan-selection',
                                duration: 2000
                            });
                            payBaseUrl1 = resolvePayBaseUrl();
                            targetUrl = ensureAbsoluteUrl(redirectUrl1, payBaseUrl1);
                            setTimeout(function() {
                                if (window.ide === 'vscode' && window.vscode) {
                                    window.vscode.postMessage({
                                        messageType: 'openUrl',
                                        data: targetUrl
                                    });
                                } else {
                                    window.location.href = targetUrl;
                                }
                            }, 2000);
                        } else {
                            console.error('❌ 결제 리다이렉트 정보를 해석하지 못했습니다.', {
                                orderResult: orderResult
                            });
                            toast.error('결제 페이지로 이동할 수 없습니다. 고객지원에 문의해주세요.', {
                                id: 'plan-selection'
                            });
                        }
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        console.error('❌ 플랜 선택 처리 중 오류:', error);
                        toast.error('플랜 선택 중 오류가 발생했습니다.', {
                            id: 'plan-selection'
                        });
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setLoadingPlanId(null);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function(plan) {
            return _ref.apply(this, arguments);
        };
    }(), [
        accessToken,
        authenticatedUserId,
        currentSubscription,
        navigate,
        callSafely,
        fetchCurrentSubscription
    ]);
    // 컴포넌트 마운트 시 페이지 초기화
    useEffect(function() {
        console.log('PricingPage useEffect 실행: 페이지 초기화를 시작합니다.');
        initializePage();
    }, [
        initializePage
    ]);
    // 컴포넌트 언마운트 시 cleanup
    useEffect(function() {
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return {
        // 상태
        availablePlans: availablePlans,
        plansLoading: plansLoading,
        plansError: plansError,
        currentSubscription: currentSubscription,
        subscriptionLoading: subscriptionLoading,
        loadingPlanId: loadingPlanId,
        // 함수
        handlePlanSelect: handlePlanSelect,
        fetchAvailablePlans: fetchAvailablePlans,
        fetchCurrentSubscription: fetchCurrentSubscription,
        initializePage: initializePage,
        // 유틸리티
        isAuthenticated: !!accessToken && !!authenticatedUserId,
        user: user,
        accessToken: accessToken
    };
};
